import { apiService } from './api';
import type { SearchRequest, SearchResponse, SearchHistory, SearchResult } from '../types/search';
import { logger } from '../utils/logger';


export const searchService = {
  async search(request: SearchRequest): Promise<SearchResponse> {
    const params = new URLSearchParams();

    if (request.query) params.append('q', request.query);
    if (request.startDate) params.append('startDate', request.startDate);
    if (request.endDate) params.append('endDate', request.endDate);
    if (request.fileType) params.append('fileType', request.fileType);
    if (request.author) params.append('author', request.author);
    if (request.tags.length > 0) {
      request.tags.forEach(tag => params.append('tags', tag));
    }
    params.append('sortBy', request.sortBy);
    params.append('sortOrder', request.sortOrder);
    params.append('page', request.page.toString());
    params.append('pageSize', request.pageSize.toString());

    const response = await apiService.get(`/api/search?${params.toString()}`);
    return response as SearchResponse;
  },

  async saveSearchHistory(userId: string, query: string, filters?: any): Promise<void> {
    try {
      await apiService.post('/api/search/history', {
        userId,
        query,
        filters
      });
    } catch (error) {
      // Silently fail - search history saving should not block the search
      logger.error('Failed to save search history:', error);
    }
  },

  async getSearchHistory(limit: number = 10, userId?: string, page: number = 1): Promise<{ history: SearchHistory[], totalCount: number }> {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    params.append('page', page.toString());
    if (userId) {
      params.append('userId', userId);
    }

    const responseData = await apiService.get(`/api/search/history?${params.toString()}`) as any;
    return {
      history: Array.isArray(responseData.history) ? responseData.history : [],
      totalCount: responseData.totalCount || 0
    };
  }
};
